export default {
  "customs-privacy": () => import("/home/circleci/project/layouts/customs-privacy.vue").then(m => m.default || m),
  default: () => import("/home/circleci/project/layouts/default.vue").then(m => m.default || m),
  privacy: () => import("/home/circleci/project/layouts/privacy.vue").then(m => m.default || m)
}